// extend libraries
import { Crncy, CrncyProps } from '@paywithextend/localization'
import React from 'react'
import { getLocaleInfo } from 'src/localization/locales'
import { useCurrencyFormatter } from 'src/localization/useCurrencyFormatter'
import { useNullSafeLocale } from 'src/localization/useNullSafeLocale'

export { useCurrencyFormatter }

type CrncyOwnProps = Omit<CrncyProps, 'locale' | 'defaultDisplayCurrency'>

/** @deprecated */
const CrncyContainer = (props: CrncyOwnProps): JSX.Element => {
  const locale = useNullSafeLocale()

  return (
    <Crncy
      locale={locale}
      defaultDisplayCurrency={getLocaleInfo(locale).currency}
      {...props}
    />
  )
}

export default CrncyContainer
